export default "__VITE_ASSET__f2d30648__"